import HeroSearch from './HeroSearch';
import TrustBadges from './TrustBadges';
import { MdVerified } from 'react-icons/md';
import { t } from '../../utils/i18n';
import heroImage from '../../assets/landing/hero-family-care.jpg';

export default function HeroSection({
  searchMode,
  onSearchModeChange,
  searchQuery,
  onSearchQueryChange,
  onLocationSelect,
  onSearch,
  locationAutocompleteRef,
  children,
}) {
  return (
    <section className="landing-hero">
      <div className="landing-container">
        <div className="landing-hero-grid">
          <div className="landing-hero-copy">
            <span className="landing-hero-eyebrow">{t('landing.hero.eyebrow')}</span>
            <h1 className="landing-hero-title">{t('landing.hero.title')}</h1>
            <p className="landing-hero-lead">{t('landing.hero.descriptionShort')}</p>

            <HeroSearch
              searchMode={searchMode}
              onSearchModeChange={onSearchModeChange}
              searchQuery={searchQuery}
              onSearchQueryChange={onSearchQueryChange}
              onLocationSelect={onLocationSelect}
              onSearch={onSearch}
              locationAutocompleteRef={locationAutocompleteRef}
            />

            <TrustBadges />
          </div>

          <div className="landing-hero-media">
            <figure className="landing-hero-photo">
              <img
                src={heroImage}
                alt={t('landing.hero.imageAlt')}
                width="1400"
                height="1050"
                loading="eager"
                fetchPriority="high"
              />
            </figure>
            <div className="landing-hero-badge">
              <MdVerified aria-hidden="true" />
              <span>{t('landing.hero.badgeVerified')}</span>
            </div>
          </div>
        </div>
      </div>

      {children && (
        <div className="landing-container mt-10 sm:mt-12 relative z-20 w-full">
          {children}
        </div>
      )}
    </section>
  );
}
